/**
 * @file routes/_app/me/report-styles/route.tsx
 * @description 報告樣式模板 Layout 路由（M2）。
 */

import { Outlet, createFileRoute } from '@tanstack/react-router';

/** TanStack Router 路由定義 */
export const Route = createFileRoute('/_app/me/report-styles')({
  component: () => <Outlet />,
});
